import { returnAction } from '../return-action.util';
import { ActionEnum } from '../../../enum/action.enum';

export const setSortForBlockLinkedData = () => returnAction(ActionEnum.SET_SORT_FOR_BLOCK_LINKED_DATA);
